import React, { useEffect } from 'react';
import './support.css';

export default function Support() {
  useEffect(() => {
    document.title = 'Support • Telome';
  }, []);

  return (
    <div className="support-wrap">
      <div className="support-card">
        <h1 className="support-title">About Telome</h1>

        <p className="support-intro">
          Have feedback, need help, found a bug, want to terminate your account, or have a business inquiry?
          We’d love to hear from you.
        </p>

        <div className="support-section">
          <h2>Get in touch</h2>
          <p className="support-text">
            Email us any time at{' '}
            <a
              className="support-link"
              href="mailto:support@telome.ai?subject=Telome%20Support%20Request"
              rel="noopener noreferrer"
            >
              support@telome.ai
            </a>
            .
          </p>
        </div>

        <div className="support-faq">
          <ul>
            <li>Need help with a Telome feature?</li>
            <li>Found a bug or having issues with the website/app?</li>
            <li>Have a business-related question?</li>
          </ul>
        </div>

        <p className="support-footnote">
          We typically respond as soon as possible. Include screenshots or short videos if that helps us reproduce an issue.
        </p>
      </div>
    </div>
  );
}
